const selectors = {
	wrapper: "[data-quantity-selector]",
	input: "[data-quantity-selector-input]",
	increment: "[data-quantity-selector-increment]",
	decrement: "[data-quantity-selector-decrement]"
};

(function () {
	const quantitySelectors = document.querySelectorAll(selectors.wrapper);

	quantitySelectors.forEach((quantitySelector) =>
		initQuantitySelector(quantitySelector)
	);

	function initQuantitySelector(quantitySelector) {
		disableQuantityButtons(quantitySelector);

		quantitySelector.addEventListener("click", onQuantityChange);
	}

	function disableQuantityButtons(quantitySelector) {
		const input = quantitySelector.querySelector(selectors.input);

		if (!input) {
			return null;
		}

		const incrementButton = quantitySelector.querySelector(
			selectors.increment
		);
		const decrementButton = quantitySelector.querySelector(
			selectors.decrement
		);

		incrementButton.disabled = +input.value + 1 > input.max;
		decrementButton.disabled = +input.value - 1 < input.min;
	}

	function onQuantityChange(event) {
		const input = this.querySelector(selectors.input);

		if (!input) {
			return null;
		}

		const target = event.target;
		const isIncrement = target.closest(selectors.increment);
		const isDecrement = target.closest(selectors.decrement);

		if (!isIncrement && !isDecrement) {
			return null;
		}

		const changeValue = isIncrement ? 1 : -1;

		const valueBefore = +input.value;
		const valueAfter = valueBefore + changeValue;

		const canIncrement = isIncrement && valueAfter <= input.max;
		const canDecrement = isDecrement && valueAfter >= input.min;

		if (canIncrement || canDecrement) {
			input.value = valueAfter;
		}

		disableQuantityButtons(this);
	}
})();
